export enum ContactMethod {
  Telegram = 'Telegram',
  Phone = 'Phone',
  Email = 'Email',
  Whatsapp = 'Whatsapp',
  Other = 'Other',
}
